import { useMemo } from 'react';

const qs = require('qs');

export const useQuery = <T = unknown>() => useMemo(() => qs.parse(window.location.search.slice(1)) as Partial<T>, [window.location.search]);
